import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { InnerBlocks, YoureDoingSomeThingWrong } from '../assets/components';

export function BoxedSection({ data, ...rest }) {
  const { attributes, innerBlocks } = data;

  const { className, tagName: Tag, blockClass, prefix, anchor, style } = attributes;

  const blockClasses = classnames(blockClass, className, {});

  const innerWrapClasses = classnames(`${prefix}__wrap`, {});

  const innerBlocksClasses = classnames(`${prefix}__inner-blocks`, {});

  const hasInnerBlocks = !isEmpty(innerBlocks);

  const styles = {
    color: style && style.color && style.color.text,
    backgroundColor: style && style.color && style.color.background,
  };

  const tip = `please remove empty boxed sections`;

  return (
    <>
      <Tag id={anchor} className={blockClasses} style={styles}>
        <div className={innerWrapClasses}>
          {hasInnerBlocks ? (
            <InnerBlocks className={innerBlocksClasses} blocks={innerBlocks} />
          ) : (
            <YoureDoingSomeThingWrong tip={tip} />
          )}
        </div>
      </Tag>
    </>
  );
}
